import React from 'react';

// Remove qualquer tag HTML, mantendo apenas o texto (ex.: para campos de texto puro).
export function stripHtmlTags(text: string): string {
    if (!text) return text;
    return text.replace(/<[^>]*>/g, '');
}

// Converte <b>/<strong> vindos de dados externos em negrito, sem usar dangerouslySetInnerHTML.
// Outras tags HTML são removidas, mantendo apenas o texto.
export function renderBoldTags(text: string): React.ReactNode {
    if (!text) return text;

    const parts = text.split(/<(?:b|strong)\b[^>]*>([\s\S]*?)<\/(?:b|strong)>/gi);

    return parts.map((part, index) =>
        index % 2 === 1
            ? <strong key={index} className='fw-bolder'>{stripHtmlTags(part)}</strong>
            : <React.Fragment key={index}>{stripHtmlTags(part)}</React.Fragment>
    );
}
